import type { MaybeRef } from "vue"
import type { ServerResponseV1 } from "@/http"
import { useQuery } from "@tanstack/vue-query"
import { toValue } from "vue"
import { v1 } from "@/axios"

interface UseListTagsOptions {
  enabled?: MaybeRef<boolean>
}

export async function listTags(eventVaultId: number) {
  const response = await v1.get<ServerResponseV1<Array<string>>>(`/${eventVaultId}/tags`)

  return response.data?.data
}

export const LIST_TAGS_KEY = "listTags"

export function useListTags(eventVaultId?: MaybeRef<number>, options: UseListTagsOptions = {}) {
  const { enabled } = options

  return useQuery({
    queryKey: [LIST_TAGS_KEY, eventVaultId],
    queryFn: () => listTags(toValue(eventVaultId)!),
    enabled: !!toValue(eventVaultId) && enabled,
    initialData: [],
  })
}
